/**
* @file 活动管理-拉新活动
* */
<template>
  <div id="order">
    <custom-table addText="创建活动" @addFn="actionFn({ type: 'add'})" has-organization="true" ref="customTable"
                  :customOptions="customOptions" :columns="columns"
                  labelWidth="135" style="height: 100%">
      <template slot="table-operation">
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="actionFn({ type: 'look',row: row })">查看
            </el-button>

            <el-button type="text"
                       v-if="[1,2].includes(row.status)"
                       @click="actionFn({ type: 'toViod',row: row })">作废
            </el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{ row.created | filterTime }}</template>
        <template
            v-else-if="['validityStartTime','validityEndTime','created','finishTime'].includes(item.prop)">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop == 'schedulingNo'">
          <span class="link" @click="actionFn({ type: 'look',row: row })">{{ row.schedulingNo }}</span>
        </template>


        <template v-else-if="item.prop == 'status'">

          <span v-if="row.status == 1">{{ row.status | filterConst('INVITATIONTYPE') }} </span>
          <span v-else-if="row.status == 0" class="util-color-secondary">{{
              row.status | filterConst('INVITATIONTYPE')
            }} </span>
          <span v-else-if="row.status == 2" class="util-color-success">{{
              row.status | filterConst('INVITATIONTYPE')
            }} </span>
          <span v-else-if="row.status == 3" class="util-color-secondary">{{
              row.status | filterConst('INVITATIONTYPE')
            }} </span>
        </template>
        <template v-else-if="item.prop == 'totalActivityAmount'">
          {{ (row.totalActivityAmount || 0) }}元
        </template>
        <template v-else-if="item.prop == 'activityNo'">
          <span @dblclick="$utils.dblclickCopy">{{ row.activityNo }}</span>
        </template>
        <template v-else-if="item.prop == 'activityAmount'">
          {{ (row.activityAmount || 0) }}元
        </template>

        <template v-else-if="item.prop == 'prizePoolAmount'">
          <span> {{ ((row.prizePoolAmount || 0) - (row.totalActivityAmount || 0)) | filterMoney }}元</span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <el-drawer
        title=""
        :visible.sync="show"
        destroy-on-close
        :before-close="handClose"
    >
      <chargeOrderDetails v-if="show" :rowData="rowData"></chargeOrderDetails>
    </el-drawer>

  </div>
</template>

<script>


export default {
  name: "order",
  components: {

    chargeOrderDetails: () => import("./components/chargeOrderDetails"),
  },
  data() {
    return {
      tabAction: "all",
      loading: false,
      refundFee: null,
      refundState: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/hitchRide/activity",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "radioGroup", field: "status", name: "订单类型",
            value: "",
            option: [{value: '', label: '全部'}, ...this.$const.INVITATIONTYPE],
          },
        ],
      },
      // 表头
      columns: [
        {prop: "activityNo", label: "活动编号", minWidth: 130},
        {prop: "status", label: "活动状态", minWidth: 100},
        {prop: "validityStartTime", label: "活动开始时间", minWidth: 150},
        {prop: "validityEndTime", label: "活动结束时间", minWidth: 150},
        {prop: "activityAmount", label: "首单奖励", minWidth: 100},
        {prop: "validityNum", label: "完成首单(人)"},
        {prop: "totalActivityAmount", label: "累计发放金额"},
        {prop: "prizePoolAmount", label: "奖池余额(元)", minWidth: 100},
      ],
      show: false,
      showCancel: false,
      rowData: {}
    };
  },
  watch: {},
  methods: {
    handClose() {
      this.rowData = {}
      this.show = false
    },
    actionFn({type, row}) {
      switch (type) {
        case "look":
          this.rowData = row;
          this.show = true;
          break;
        case  'add':
          this.$router.push('/chargeOrderForm')
          break
        case 'toViod':
          this.$confirm('活动作废后将停止后续奖励发放，是否确认作废活动？', '活动作废', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.put(`/api/v1/manage/hitchRide/activity`, {...row, status: 0}).then(({code}) => {
              if (code === 1) {
                this.$message.success('作废成功')
                this.$refs.customTable.listFn();
              }
            })
          }).catch(() => {
          });
          break
      }
    },
    /**
     * 状态改变
     */
  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    }
  },
};
</script>

<style scoped lang="less">
#order {
  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
  }
}
</style>
